import { TruncatedText } from './ui/TooltipCard';
import Badge from './ui/Badge';

function VenueCard({ venue, className = '', cityClassName = '', actions, ...cardProps }) {
  return (
    <div className={`card w-full ${className}`} {...cardProps}>
      <div className="px-6 py-4">
        <div className="flex justify-between items-start">
          <div className="flex items-center gap-2 min-w-0">
            {venue.is_closed && <Badge>Closed</Badge>}
            <h2 className="card-title min-w-0">
              <TruncatedText>{venue.venue_name}</TruncatedText>
            </h2>
          </div>
          <div className="flex gap-2 shrink-0 ml-2">{actions}</div>
        </div>
        <p>{venue.address1}</p>
        <p>{venue.neighborhood}</p>
        {venue.city && <p className={`text-xs mt-1 ${cityClassName}`}>{venue.city}</p>}
      </div>
    </div>
  );
}

export default VenueCard;
